import * as React from 'react';
import {FunctionComponent} from 'react';

interface OwnProps {}

export const Csrf: FunctionComponent<OwnProps> = ({}) => {
    const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
    if (!token) {
        return null;
    }

    return <input type="hidden" name="_token" value={token} />;
};
